import axios from 'axios'
import endpoints from '@/api/endpoints'

export default {
  async getWOs() {
    return axios.get(endpoints.wos).then((response) => {
      return response.data
    })
  },
  async createWO(wo) {
    return axios.post(endpoints.wos, wo).then((response) => {
      return response.data
    })
  },
  async deleteWO(wo) {
    return axios.delete(endpoints.wos + wo.id + '/').then((response) => {
      return response.data
    })
  },
  async thinCreateWO(wo) {
    return axios.post(endpoints.wos + 'thin_create/', wo).then((response) => {
      return response.data
    })
  },
  async bulkCreateWOs(arr) {
    // arr is an array of WOs
    // This should ONLY be used for bulk creating SNOW work orders, for generating schedule templates
    return axios.patch(endpoints.wos + 'bulk_create/', arr).then((response) => {
      return response.data
    })
  },
  async getWOTemplates() {
    return axios.get(endpoints.wos + '?is_template=true').then((response) => {
      return response.data
    })
  },
  async getWO(woID) {
    return axios.get(endpoints.wos + woID + '/').then((response) => {
      return response.data
    })
  },
  async getQuickViewWO(woID) {
    return axios.get(endpoints.wos + woID + '/quick_view/').then((response) => {
      return response.data
    })
  },
  async updateWO(wo) {
    console.log(wo.id);
    delete wo.files // bandaid for files issues - MJ (since an older files array may overwrite recently attached files on wo edit/save)
    return axios.patch(endpoints.wos + wo.id + '/', wo).then((response) => {
      return response.data
    })
  },
  async bulkUpdateWOs(wos) {
    // NO LONGER USED
    return axios.patch(endpoints.wos + 'bulk_update/', wos).then((response) => {
      return response.data
    })
  },
  async getProjectWOs(projID) {
    return axios.get(endpoints.wos + 'for_project/?project=' + projID + '&is_template=false').then((response) => {
      return response.data
    })
  },
  async createCrewVisitForWO(obj) {
    return axios.post(endpoints.crewVisits, obj).then((response) => {
      return response.data
    })
  },
  async getCrewVisitsForWO(objID) {
    return axios.get(endpoints.crewVisits + '?work_order=' + objID).then((response) => {
      return response.data
    })
  },
  async createSchedulingLog(obj) {
    return axios.post(endpoints.schedulingLog, obj).then((response) => {
      return response.data
    })
  },
  async updateSchedulingLog(obj) {
    return axios.patch(endpoints.schedulingLog + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async getSchedulingLogForWO(objID) {
    return axios.get(endpoints.schedulingLog + '?work_order=' + objID).then((response) => {
      return response.data
    })
  },

  // api calls for fieldcrews work orders
  async getLabourForWO(objID, no_warranty = false) {
    let url = `${endpoints.woLabour}?work_order=${objID}&`;

    if (no_warranty) {
      url += `no_warranty=true&`;
    }
    return axios.get(url).then((response) => {
      return response.data
    })
  },
  async getProductForWO(woID, no_warranty = false) {
    let url = `${endpoints.woProduct}?work_order=${woID}&`;


    if (no_warranty) {
      url += `no_warranty=true&`;
    }
    return axios.get(url).then((response) => {
      return response.data
    })
  },
  async createProductForWO(obj) {
    return axios.post(endpoints.woProduct, obj).then((response) => {
      return response.data
    })
  },
  async updateProductForWO(obj) {
    return axios.patch(endpoints.woProduct + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async deleteProductForWO(obj) {
    return axios.delete(endpoints.woProduct + obj.id + '/').then((response) => {
      return response.data
    })
  },
  async createLabourForWO(obj) {
    return axios.post(endpoints.woLabour, obj).then((response) => {
      return response.data
    })
  },
  async updateLabourForWO(obj) {
    return axios.patch(endpoints.woLabour + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async deleteLabourForWO(objID) {
    return axios.delete(endpoints.woLabour + objID + '/').then((response) => {
      return response.data
    })
  },
  async woProductExchange(objID, products) {
    // objID is the id of the work order that this products array is attached to
    return axios.post(endpoints.wos + objID + '/' + 'update_wo_products/', products).then((response) => {
      return response.data
    })
  },
  async woSearch(search) {
    return axios.get(endpoints.wosSearch + '?name=' + search + '&number=' + search + '&site_address=' + search).then((response) => {
      return response.data
    })
  },
  async wosReport(parameters) {
    return axios.get(endpoints.wosReport + parameters).then((response) => {
      return response.data
    })
  },
  async getWOsReadyForOffice() {
    return axios.get(endpoints.wos + '?is_complete=true&office_complete=false&archived=false').then((response) => {
      return response.data
    })
  },
  async generateInvoiceFromWO(woID) {
    return axios.get(endpoints.wos + woID + '/generate_invoice/').then((response) => {
      return response.data
    })
  },
  async addFileToWO(id, fileId) {
    return axios.post(endpoints.wos + id + '/add_file/', { 'file_id': fileId }).then((response) => {
      return response.data
    })
  },


  //
  async getSUBDRevenueReportWOs(subd, from, to) {
    /*
      This endpoint returns an array of work orders, with custom fields built on the backend,
      to show the revenue of all work orders generated between a certain time frame, and for either
      startups or blowdowns. 

      The variables coming in are:
        subd  --> must be either `su` or `bd` and will tell the backend what kind of work orders to search for
        from  --> a date string in the format of YYYY-MM-DD which is the starting point to filter
        to  --> a date string in the format of YYYY-MM-DD which is the ending point to filter

        All work orders of type `subd` between the `from` and `to` will be searched by the backend.
    */
    return axios.get(endpoints.wos + 'subd_report/?subd=' + subd + '&from=' + from + '&to=' + to).then((response) => {
      return response.data
    })
  },
  async getEstimateWOs(estID) {
    return axios.get(endpoints.wos + '?estimate=' + estID).then((response) => {
      return response.data
    })
  },
  async getWOTypes() {
    return axios.get(endpoints.woTypes).then((response) => {
      return response.data;
    })
  }
}
